import { apiRequest } from './apiClient';

export const fetchLocations = async () =>
  (await apiRequest('/locations')).data;

export const createLocation = async (type, payload) =>
  (await apiRequest(`/locations/${type}`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })).data;

export const updateLocation = async (type, id, payload) =>
  (await apiRequest(`/locations/${type}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })).data;

export const deleteLocation = (type, id) =>
  apiRequest(`/locations/${type}/${id}`, { method: 'DELETE' });
